import { apiGet } from 'api';
import { GetFilterCategoriesResponse } from '../../types';

export const getFilterCategories = (): Promise<GetFilterCategoriesResponse> =>
  apiGet<GetFilterCategoriesResponse>('consultationcategories');
